// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
};

/**
 * TeacherMatchingTierEnum
 */
export const TeacherMatchingTierEnum = {
    TIER_1: 'tier_1',
    TIER_2: 'tier_2',
    TIER_3: 'tier_3'
} as const;

/**
 * TeacherMatchingTierEnum
 */
export type TeacherMatchingTierEnum = typeof TeacherMatchingTierEnum[keyof typeof TeacherMatchingTierEnum];

/**
 * TeacherFitStrengthEnum
 */
export const TeacherFitStrengthEnum = {
    VERY_STRONG_FIT: 'very_strong_fit',
    STRONG_FIT: 'strong_fit',
    MODERATE_FIT: 'moderate_fit',
    POTENTIAL_FIT: 'potential_fit',
    BAD_FIT: 'bad_fit'
} as const;

/**
 * TeacherFitStrengthEnum
 */
export type TeacherFitStrengthEnum = typeof TeacherFitStrengthEnum[keyof typeof TeacherFitStrengthEnum];

/**
 * TeacherControlGroupEnum
 */
export const TeacherControlGroupEnum = {
    CONTROL: 'control',
    TREATMENT: 'treatment'
} as const;

/**
 * TeacherControlGroupEnum
 */
export type TeacherControlGroupEnum = typeof TeacherControlGroupEnum[keyof typeof TeacherControlGroupEnum];

/**
 * SummaryRequest
 */
export type SummaryRequest = {
    /**
     * School Nces Ids
     */
    school_nces_ids: Array<string>;
    /**
     * Start Date
     */
    start_date: string;
    /**
     * End Date
     */
    end_date: string;
};

/**
 * Summary
 */
export type Summary = {
    /**
     * Candidates Recommended
     */
    candidates_recommended: number;
    /**
     * Schools Count
     */
    schools_count: number;
    /**
     * Active Schools Count
     */
    active_schools_count: number;
    /**
     * Candidates Reached Out
     */
    candidates_reached_out: number;
    /**
     * Schools Reached Out Count
     */
    schools_reached_out_count: number;
    /**
     * Connections Made
     */
    connections_made: number;
    /**
     * Schools Connected Count
     */
    schools_connected_count: number;
};

/**
 * SchoolsAnalyticsRequest
 */
export type SchoolsAnalyticsRequest = {
    /**
     * School Nces Ids
     */
    school_nces_ids: Array<string>;
    /**
     * End Date
     */
    end_date: string;
};

/**
 * SchoolsAnalytics
 */
export type SchoolsAnalytics = {
    /**
     * Schools
     */
    schools: Array<SchoolMetrics>;
};

/**
 * SchoolActivationStatus
 */
export const SchoolActivationStatus = {
    ACTIVE_THIS_WEEK: 'active_this_week',
    ACTIVE_THIS_MONTH: 'active_this_month',
    DORMANT: 'dormant',
    NEVER_ACTIVE: 'never_active'
} as const;

/**
 * SchoolActivationStatus
 */
export type SchoolActivationStatus = typeof SchoolActivationStatus[keyof typeof SchoolActivationStatus];

/**
 * SchoolMetrics
 */
export type SchoolMetrics = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    /**
     * Recs This Week
     */
    recs_this_week: number;
    /**
     * Prospects Reached Out This Week
     */
    prospects_reached_out_this_week: number;
    activation_status: SchoolActivationStatus;
    /**
     * Last Action At
     */
    last_action_at: string | null;
    /**
     * Actions Taken
     */
    actions_taken: number;
    /**
     * Actions Possible
     */
    actions_possible: number;
    /**
     * Connections This Week
     */
    connections_this_week: number;
    /**
     * Connections Season To Date
     */
    connections_season_to_date: number;
};

/**
 * SchoolResolvedMatchesResponse
 */
export type SchoolResolvedMatchesResponse = {
    /**
     * Matches
     */
    matches: Array<SchoolResolvedMatchItem>;
};

/**
 * MessageEvent
 */
export type MessageEvent = {
    actor: MatchActorEnum;
    /**
     * Occurred At
     */
    occurred_at: string;
    /**
     * Event Type
     */
    event_type?: 'message';
    /**
     * Content
     */
    content: string;
};

/**
 * MatchActorEnum
 */
export const MatchActorEnum = {
    SCHOOL: 'school',
    CANDIDATE: 'candidate',
    SYSTEM: 'system'
} as const;

/**
 * MatchActorEnum
 */
export type MatchActorEnum = typeof MatchActorEnum[keyof typeof MatchActorEnum];

/**
 * ActionTypeEnum
 */
export const ActionTypeEnum = {
    CONNECT: 'CONNECT',
    REJECT: 'REJECT',
    SCHOOL_ACCEPT: 'SCHOOL_ACCEPT',
    SCHOOL_REJECT: 'SCHOOL_REJECT',
    SCHOOL_INVITE_TO_APPLY: 'SCHOOL_INVITE_TO_APPLY',
    SCHOOL_MARK_HIRED: 'SCHOOL_MARK_HIRED',
    CANDIDATE_ACCEPT: 'CANDIDATE_ACCEPT',
    CANDIDATE_REJECT: 'CANDIDATE_REJECT',
    CANDIDATE_MAYBE: 'CANDIDATE_MAYBE',
    CANDIDATE_EXPRESS_INTEREST: 'CANDIDATE_EXPRESS_INTEREST',
    SYSTEM_EXPIRE: 'SYSTEM_EXPIRE'
} as const;

/**
 * ActionTypeEnum
 */
export type ActionTypeEnum = typeof ActionTypeEnum[keyof typeof ActionTypeEnum];

/**
 * ActionEvent
 */
export type ActionEvent = {
    actor: MatchActorEnum;
    /**
     * Occurred At
     */
    occurred_at: string;
    /**
     * Event Type
     */
    event_type?: 'action';
    action: ActionTypeEnum;
};

/**
 * ConnectCandidateTier
 */
export const ConnectCandidateTier = {
    TIER_1: 'tier_1',
    TIER_2: 'tier_2',
    NONE: 'none'
} as const;

/**
 * ConnectCandidateTier
 */
export type ConnectCandidateTier = typeof ConnectCandidateTier[keyof typeof ConnectCandidateTier];

/**
 * MatchStatusEnum
 */
export const MatchStatusEnum = {
    RECOMMENDED_TO_SCHOOL: 'recommended_to_school',
    RECOMMENDED_TO_CANDIDATE: 'recommended_to_candidate',
    RECOMMENDED_TO_SCHOOL_ACCEPTED_BY_SCHOOL: 'recommended_to_school_accepted_by_school',
    RECOMMENDED_TO_SCHOOL_REJECTED_BY_SCHOOL: 'recommended_to_school_rejected_by_school',
    RECOMMENDED_TO_CANDIDATE_ACCEPTED_BY_CANDIDATE: 'recommended_to_candidate_accepted_by_candidate',
    RECOMMENDED_TO_CANDIDATE_REJECTED_BY_CANDIDATE: 'recommended_to_candidate_rejected_by_candidate',
    RECOMMENDED_TO_SCHOOL_ACCEPTED_BY_SCHOOL_ACCEPTED_BY_CANDIDATE: 'recommended_to_school_accepted_by_school_accepted_by_candidate',
    RECOMMENDED_TO_SCHOOL_ACCEPTED_BY_SCHOOL_REJECTED_BY_CANDIDATE: 'recommended_to_school_accepted_by_school_rejected_by_candidate',
    RECOMMENDED_TO_CANDIDATE_ACCEPTED_BY_CANDIDATE_ACCEPTED_BY_SCH: 'recommended_to_candidate_accepted_by_candidate_accepted_by_sch',
    RECOMMENDED_TO_CANDIDATE_ACCEPTED_BY_CANDIDATE_REJECTED_BY_SCH: 'recommended_to_candidate_accepted_by_candidate_rejected_by_sch',
    EXPRESS_INTEREST_BY_CANDIDATE_TO_SCHOOL: 'express_interest_by_candidate_to_school',
    EXPRESS_INTEREST_BY_CANDIDATE_TO_SCHOOL_ACCEPTED_BY_SCHOOL: 'express_interest_by_candidate_to_school_accepted_by_school',
    EXPRESS_INTEREST_BY_CANDIDATE_TO_SCHOOL_REJECTED_BY_SCHOOL: 'express_interest_by_candidate_to_school_rejected_by_school',
    EXPIRED: 'expired',
    INVITED: 'invited',
    HIRED: 'hired'
} as const;

/**
 * MatchStatusEnum
 */
export type MatchStatusEnum = typeof MatchStatusEnum[keyof typeof MatchStatusEnum];

/**
 * SchoolResolvedMatchItem
 */
export type SchoolResolvedMatchItem = {
    /**
     * Matching Uuid
     */
    matching_uuid: string;
    /**
     * Candidate Id
     */
    candidate_id: string;
    match_status: MatchStatusEnum;
    /**
     * Distance From School
     */
    distance_from_school?: number | null;
    /**
     * Matched Grades
     */
    matched_grades?: Array<string>;
    /**
     * Matched Subjects
     */
    matched_subjects?: Array<string>;
    connect_candidate_tier: ConnectCandidateTier;
    /**
     * Last Activity At
     */
    last_activity_at: string;
    /**
     * Latest Message Preview
     */
    latest_message_preview?: string | null;
    /**
     * Timeline
     */
    timeline?: Array<ActionEvent | MessageEvent>;
};

/**
 * SchoolRecommendation
 */
export type SchoolRecommendation = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Score
     */
    score: number;
    /**
     * Rank
     */
    rank: number;
    /**
     * Distance Miles
     */
    distance_miles: number;
    /**
     * Preference strength category
     */
    fit_strength: TeacherFitStrengthEnum;
};

/**
 * SchoolMatchesResponse
 */
export type SchoolMatchesResponse = {
    /**
     * Matches
     */
    matches: Array<SchoolMatchItem>;
};

/**
 * MessageData
 */
export type MessageData = {
    /**
     * Message
     */
    message: string;
    sender_type: MatchActorEnum;
};

/**
 * PrincipalPreferences
 */
export type PrincipalPreferences = {
    /**
     * Grades
     */
    grades?: Array<string> | null;
    /**
     * Subjects
     */
    subjects?: Array<string> | null;
};

/**
 * SchoolMatchItem
 */
export type SchoolMatchItem = {
    /**
     * Matching Uuid
     */
    matching_uuid: string;
    /**
     * Candidate Id
     */
    candidate_id: string;
    match_status: MatchStatusEnum;
    /**
     * Distance From School
     */
    distance_from_school?: number | null;
    /**
     * Matched Grades
     */
    matched_grades?: Array<string>;
    /**
     * Matched Subjects
     */
    matched_subjects?: Array<string>;
    /**
     * Created At
     */
    created_at: string;
    teacher_fit_strength?: TeacherFitStrengthEnum | null;
    teacher_matching_tier?: TeacherMatchingTierEnum | null;
    connect_candidate_tier: ConnectCandidateTier;
    /**
     * Strength Ranking
     */
    strength_ranking?: number | null;
    principal_preferences?: PrincipalPreferences | null;
    message_data?: MessageData | null;
};

/**
 * SchoolFeatures
 */
export type SchoolFeatures = {
    /**
     * Nces Id
     */
    nces_id: string;
    /**
     * Achievement Growth
     */
    achievement_growth: number;
    /**
     * Novice Teachers Percentage
     */
    novice_teachers_percentage: number;
    /**
     * Free Reduced Lunch Percentage
     */
    free_reduced_lunch_percentage: number;
    /**
     * Student Teacher Ratio
     */
    student_teacher_ratio: number;
    /**
     * Average Salary
     */
    average_salary: number;
    /**
     * Distance
     */
    distance: number;
};

/**
 * SchoolAwaitingResponse
 */
export type SchoolAwaitingResponse = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    /**
     * Candidates
     */
    candidates: Array<SchoolMatchItem>;
};

/**
 * SaveResponseResult
 */
export type SaveResponseResult = {
    /**
     * Success
     */
    success: boolean;
    quiz_status: QuizStatus;
};

/**
 * QuizStatus
 */
export const QuizStatus = {
    NOT_TAKEN: 'not_taken',
    INCOMPLETE: 'incomplete',
    COMPLETE: 'complete'
} as const;

/**
 * QuizStatus
 */
export type QuizStatus = typeof QuizStatus[keyof typeof QuizStatus];

/**
 * RawCandidateNotificationData
 *
 * Relaxed schema for notification data — accepts incomplete payloads.
 * Validation for notification dispatch happens at the service layer.
 */
export type RawCandidateNotificationData = {
    /**
     * Candidate Email
     */
    candidate_email?: string | null;
    /**
     * Candidate First Name
     */
    candidate_first_name?: string | null;
    /**
     * Candidate Last Name
     */
    candidate_last_name?: string | null;
    /**
     * Apply Link
     */
    apply_link?: string | null;
};

/**
 * QuizStatusResponse
 */
export type QuizStatusResponse = {
    status: QuizStatus;
};

/**
 * QuizQuestionsResponse
 */
export type QuizQuestionsResponse = {
    quiz_status: QuizStatus;
    /**
     * Questions
     */
    questions: Array<QuizQuestion>;
};

/**
 * QuizQuestionEntry
 */
export type QuizQuestionEntry = {
    /**
     * Uuid
     */
    uuid: string;
    /**
     * Entry Display Order
     */
    entry_display_order: number;
    /**
     * Synthetic Achievement Growth
     */
    synthetic_achievement_growth: number;
    /**
     * Synthetic Novice Teachers Percentage
     */
    synthetic_novice_teachers_percentage: number;
    /**
     * Synthetic Free Reduced Lunch Percentage
     */
    synthetic_free_reduced_lunch_percentage: number;
    /**
     * Synthetic Student Teacher Ratio
     */
    synthetic_student_teacher_ratio: number;
    /**
     * Synthetic Salary
     */
    synthetic_salary: number;
    /**
     * Synthetic Distance
     */
    synthetic_distance: number;
    /**
     * Current Ranking
     */
    current_ranking?: number | null;
};

/**
 * QuizQuestion
 */
export type QuizQuestion = {
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Question Group
     */
    question_group: string;
    /**
     * Entries
     */
    entries: Array<QuizQuestionEntry>;
    /**
     * Is Answered
     */
    is_answered?: boolean;
};

/**
 * PrincipalContact
 */
export type PrincipalContact = {
    /**
     * Email
     */
    email?: string | null;
    /**
     * Phone
     */
    phone?: string | null;
    /**
     * Scheduling Link
     */
    scheduling_link?: string | null;
};

/**
 * OptimizationSettings
 *
 * DCE optimization algorithm settings.
 */
export type OptimizationSettings = {
    /**
     * Max Scaling Factor
     */
    max_scaling_factor: number;
    /**
     * Tolerance
     */
    tolerance: number;
};

/**
 * CandidateWillingnessToPayPerDollar
 *
 * WTP values - how much of salary candidate would trade for each feature.
 */
export type CandidateWillingnessToPayPerDollar = {
    /**
     * Achievement Growth
     */
    achievement_growth: number;
    /**
     * Novice Teachers Percentage
     */
    novice_teachers_percentage: number;
    /**
     * Free Reduced Lunch Percentage
     */
    free_reduced_lunch_percentage: number;
    /**
     * Student Teacher Ratio
     */
    student_teacher_ratio: number;
    /**
     * Distance
     */
    distance: number;
};

/**
 * CandidatePreferenceWeights
 *
 * Omega values - preference weights for each feature.
 */
export type CandidatePreferenceWeights = {
    /**
     * Achievement Growth
     */
    achievement_growth: number;
    /**
     * Novice Teachers Percentage
     */
    novice_teachers_percentage: number;
    /**
     * Free Reduced Lunch Percentage
     */
    free_reduced_lunch_percentage: number;
    /**
     * Student Teacher Ratio
     */
    student_teacher_ratio: number;
    /**
     * Salary
     */
    salary: number;
    /**
     * Distance
     */
    distance: number;
};

/**
 * MatchStatusRequest
 */
export type MatchStatusRequest = {
    /**
     * School Nces Ids
     */
    school_nces_ids: Array<string>;
};

/**
 * InvitationsResponse
 */
export type InvitationsResponse = {
    /**
     * Invitations
     */
    invitations: Array<InvitationItem>;
};

/**
 * InvitationItem
 */
export type InvitationItem = {
    /**
     * Matching Uuid
     */
    matching_uuid: string;
    /**
     * School Nces Id
     */
    school_nces_id: string;
    match_status: MatchStatusEnum;
    /**
     * Distance From School
     */
    distance_from_school?: number | null;
    /**
     * Matched Grades
     */
    matched_grades?: Array<string>;
    /**
     * Matched Subjects
     */
    matched_subjects?: Array<string>;
    /**
     * Created At
     */
    created_at: string;
    /**
     * School Message
     */
    school_message?: string | null;
    /**
     * School Message At
     */
    school_message_at?: string | null;
};

/**
 * InvitationsCountResponse
 */
export type InvitationsCountResponse = {
    /**
     * Count
     */
    count: number;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * GatewayActionRequest
 */
export type GatewayActionRequest = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    action: ActionTypeEnum;
    reason?: ActionReasonEnum | null;
    /**
     * Explanation
     */
    explanation?: string | null;
    message_data?: MessageData | null;
    notification_data?: CandidateDataForNotification | null;
};

/**
 * CandidateDataForNotification
 */
export type CandidateDataForNotification = {
    /**
     * Candidate Email
     */
    candidate_email?: string | null;
    /**
     * Candidate First Name
     */
    candidate_first_name: string;
    /**
     * Candidate Last Name
     */
    candidate_last_name?: string | null;
    /**
     * Apply Link
     */
    apply_link?: string | null;
};

/**
 * ActionReasonEnum
 */
export const ActionReasonEnum = {
    CANDIDATE_SEEN_BEFORE: 'CANDIDATE_SEEN_BEFORE',
    LACKING_SOFT_SKILLS: 'LACKING_SOFT_SKILLS',
    LOVE_OF_TEACHING: 'LOVE_OF_TEACHING',
    NO_LONGER_HIRING: 'NO_LONGER_HIRING',
    NOT_ENOUGH_EXPERIENCE: 'NOT_ENOUGH_EXPERIENCE',
    NOT_QUALIFIED: 'NOT_QUALIFIED',
    NOT_RIGHT_GRADE_LEVEL: 'NOT_RIGHT_GRADE_LEVEL',
    NOT_RIGHT_SUBJECTS_TAUGHT: 'NOT_RIGHT_SUBJECTS_TAUGHT',
    OTHER: 'OTHER',
    SCHOOLS_THEYVE_TAUGHT_AT: 'SCHOOLS_THEYVE_TAUGHT_AT',
    SUBJECT_AREA_THEY_TEACH: 'SUBJECT_AREA_THEY_TEACH',
    SUBJECTS_TAUGHT: 'SUBJECTS_TAUGHT',
    TEACHING_STYLE_PHILOSOPHY: 'TEACHING_STYLE_PHILOSOPHY',
    TOO_MUCH_EXPERIENCE: 'TOO_MUCH_EXPERIENCE',
    TYPE_OF_EXPERIENCE: 'TYPE_OF_EXPERIENCE',
    YEARS_OF_EXPERIENCE: 'YEARS_OF_EXPERIENCE',
    CANDIDATE_WOULD_NOT_BE_INTERESTED: 'CANDIDATE_WOULD_NOT_BE_INTERESTED',
    CANDIDATE_NOT_LOCATED_IN_MY_AREA: 'CANDIDATE_NOT_LOCATED_IN_MY_AREA',
    NO_LONGER_LOOKING: 'NO_LONGER_LOOKING',
    SCHOOL_TOO_FAR: 'SCHOOL_TOO_FAR',
    NO_MATCHING_OPENING: 'NO_MATCHING_OPENING',
    COMPENSATION_BENEFITS_UNMET: 'COMPENSATION_BENEFITS_UNMET',
    WRONG_ENVIRONMENT: 'WRONG_ENVIRONMENT',
    EXPIRED: 'EXPIRED'
} as const;

/**
 * ActionReasonEnum
 */
export type ActionReasonEnum = typeof ActionReasonEnum[keyof typeof ActionReasonEnum];

/**
 * ExpressInterestResponse
 */
export type ExpressInterestResponse = {
    /**
     * Success
     */
    success: boolean;
    /**
     * Notification Queued
     */
    notification_queued: boolean;
};

/**
 * ExpressInterestRequest
 */
export type ExpressInterestRequest = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    /**
     * Message
     */
    message?: string | null;
    notification_data: CandidateDataForNotification;
};

/**
 * ConnectionsResponse
 */
export type ConnectionsResponse = {
    /**
     * Connections
     */
    connections: Array<ConnectionItem>;
};

/**
 * ConnectionItem
 */
export type ConnectionItem = {
    /**
     * Matching Uuid
     */
    matching_uuid: string;
    /**
     * School Nces Id
     */
    school_nces_id: string;
    match_status: MatchStatusEnum;
    /**
     * Distance From School
     */
    distance_from_school?: number | null;
    /**
     * Matched Grades
     */
    matched_grades?: Array<string>;
    /**
     * Matched Subjects
     */
    matched_subjects?: Array<string>;
    /**
     * Last Activity At
     */
    last_activity_at: string;
    /**
     * Latest Message Preview
     */
    latest_message_preview: string | null;
    /**
     * Timeline
     */
    timeline: Array<ActionEvent | MessageEvent>;
    principal_contact: PrincipalContact | null;
};

/**
 * ConnectionsCountResponse
 */
export type ConnectionsCountResponse = {
    /**
     * Count
     */
    count: number;
};

/**
 * ConnectionInitiatedItem
 */
export type ConnectionInitiatedItem = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    /**
     * Connection Initiated
     */
    connection_initiated: boolean;
};

/**
 * CandidateResponsePayload
 */
export type CandidateResponsePayload = {
    /**
     * Responses
     */
    responses: Array<CandidateQuizResponse>;
};

/**
 * CandidateQuizResponse
 */
export type CandidateQuizResponse = {
    /**
     * Quiz Question Entry Uuid
     */
    quiz_question_entry_uuid: string;
    /**
     * School Candidate Rank
     */
    school_candidate_rank: number;
};

/**
 * CandidateRecommendationItem
 */
export type CandidateRecommendationItem = {
    /**
     * Matching Uuid
     */
    matching_uuid: string;
    /**
     * School Nces Id
     */
    school_nces_id: string;
    match_status: MatchStatusEnum;
    /**
     * Distance From School
     */
    distance_from_school: number | null;
    /**
     * Created At
     */
    created_at: string;
    teacher_fit_strength: TeacherFitStrengthEnum;
    teacher_matching_tier: TeacherMatchingTierEnum;
    teacher_control_group: TeacherControlGroupEnum;
    principal_preferences: PrincipalPreferences | null;
    /**
     * Matched Grades
     */
    matched_grades: Array<string>;
    /**
     * Matched Subjects
     */
    matched_subjects: Array<string>;
};

/**
 * CandidateRecommendationInput
 */
export type CandidateRecommendationInput = {
    /**
     * Schools
     */
    schools: Array<SchoolFeatures>;
    candidate_input: CandidateMatchingInput;
};

/**
 * CandidateMatchingInput
 */
export type CandidateMatchingInput = {
    /**
     * Grades
     */
    grades: Array<string>;
    /**
     * Subjects
     */
    subjects: Array<string>;
    /**
     * Geo Location Latitude
     */
    geo_location_latitude: string;
    /**
     * Geo Location Longitude
     */
    geo_location_longitude: string;
    /**
     * Miles Within
     */
    miles_within: number | null;
    /**
     * Preferred State Ids
     */
    preferred_state_ids: Array<number>;
    /**
     * Years Of Experience
     */
    years_of_experience: number;
    /**
     * Schools To Not Match
     */
    schools_to_not_match: Array<string>;
};

/**
 * CandidatePreferenceWeightsOutput
 */
export type CandidatePreferenceWeightsOutput = {
    /**
     * Optimization Id
     */
    optimization_id: string;
    /**
     * Candidate Id
     */
    candidate_id: string;
    /**
     * Created At
     */
    created_at: string;
    preference_weights: CandidatePreferenceWeights;
    willingness_to_pay: CandidateWillingnessToPayPerDollar;
    /**
     * Scaling Factor
     */
    scaling_factor: number;
    /**
     * Algorithm Version
     */
    algorithm_version: string;
};

/**
 * CandidateCountsResponse
 */
export type CandidateCountsResponse = {
    /**
     * Invitations Count
     */
    invitations_count: number;
    /**
     * Teacher Recommendations Count
     */
    teacher_recommendations_count: number;
};

/**
 * CandidateActivityState
 */
export const CandidateActivityState = {
    ACTIVE: 'active',
    WARNING: 'warning',
    DUE_FOR_DEACTIVATION: 'due_for_deactivation'
} as const;

/**
 * CandidateActivityState
 */
export type CandidateActivityState = typeof CandidateActivityState[keyof typeof CandidateActivityState];

/**
 * CandidateActivityRequest
 */
export type CandidateActivityRequest = {
    /**
     * Candidate Ids
     */
    candidate_ids: Array<string>;
    /**
     * Job Seeking Status Updated At By Candidate Id
     */
    job_seeking_status_updated_at_by_candidate_id?: {
        [key: string]: string;
    };
};

/**
 * CandidateActivityItem
 */
export type CandidateActivityItem = {
    /**
     * Candidate Id
     */
    candidate_id: string;
    activity_state: CandidateActivityState;
    /**
     * Oldest Pending Invite At
     */
    oldest_pending_invite_at: string | null;
};

/**
 * AwaitingSchoolResponseResult
 */
export type AwaitingSchoolResponseResult = {
    /**
     * Schools
     */
    schools: Array<SchoolAwaitingResponse>;
};

/**
 * AwaitingSchoolResponseRequest
 */
export type AwaitingSchoolResponseRequest = {
    /**
     * School Nces Ids
     */
    school_nces_ids: Array<string>;
    /**
     * End Date
     */
    end_date: string;
    /**
     * Min Age Days
     */
    min_age_days: number;
};

/**
 * ActionWithMessage
 */
export type ActionWithMessage = {
    /**
     * School Nces Id
     */
    school_nces_id: string;
    action: ActionTypeEnum;
    reason?: ActionReasonEnum | null;
    /**
     * Explanation
     */
    explanation?: string | null;
    message_data?: MessageData | null;
    notification_data?: RawCandidateNotificationData | null;
    /**
     * Candidate Id
     */
    candidate_id: string;
};

/**
 * ActionResponse
 */
export type ActionResponse = {
    /**
     * Candidate Id
     */
    candidate_id: string;
    /**
     * School Nces Id
     */
    school_nces_id: string;
    action: ActionTypeEnum;
    reason?: ActionReasonEnum | null;
    /**
     * Explanation
     */
    explanation?: string | null;
    /**
     * Message Created
     */
    message_created?: boolean;
    /**
     * Notification Queued
     */
    notification_queued?: boolean;
};

export type GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetData = {
    body?: never;
    path: {
        /**
         * School Nces Id
         */
        school_nces_id: string;
    };
    query?: never;
    url: '/api/v1/recommendation/school/{school_nces_id}/matches';
};

export type GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetError = GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetErrors[keyof GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetErrors];

export type GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponses = {
    /**
     * Successful Response
     */
    200: SchoolMatchesResponse;
};

export type GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponse = GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponses[keyof GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponses];

export type GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetData = {
    body?: never;
    path: {
        /**
         * School Nces Id
         */
        school_nces_id: string;
    };
    query?: never;
    url: '/api/v1/recommendation/school/{school_nces_id}/resolved-matches';
};

export type GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetError = GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetErrors[keyof GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetErrors];

export type GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponses = {
    /**
     * Successful Response
     */
    200: SchoolResolvedMatchesResponse;
};

export type GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponse = GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponses[keyof GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponses];

export type CreateActionApiV1ActionPostData = {
    body: ActionWithMessage;
    path?: never;
    query?: never;
    url: '/api/v1/action/';
};

export type CreateActionApiV1ActionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateActionApiV1ActionPostError = CreateActionApiV1ActionPostErrors[keyof CreateActionApiV1ActionPostErrors];

export type CreateActionApiV1ActionPostResponses = {
    /**
     * Successful Response
     */
    200: ActionResponse;
};

export type CreateActionApiV1ActionPostResponse = CreateActionApiV1ActionPostResponses[keyof CreateActionApiV1ActionPostResponses];

export type SummaryApiV1AnalyticsSummaryPostData = {
    body: SummaryRequest;
    path?: never;
    query?: never;
    url: '/api/v1/analytics/summary';
};

export type SummaryApiV1AnalyticsSummaryPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SummaryApiV1AnalyticsSummaryPostError = SummaryApiV1AnalyticsSummaryPostErrors[keyof SummaryApiV1AnalyticsSummaryPostErrors];

export type SummaryApiV1AnalyticsSummaryPostResponses = {
    /**
     * Successful Response
     */
    200: Summary;
};

export type SummaryApiV1AnalyticsSummaryPostResponse = SummaryApiV1AnalyticsSummaryPostResponses[keyof SummaryApiV1AnalyticsSummaryPostResponses];

export type SchoolsApiV1AnalyticsSchoolsPostData = {
    body: SchoolsAnalyticsRequest;
    path?: never;
    query?: never;
    url: '/api/v1/analytics/schools';
};

export type SchoolsApiV1AnalyticsSchoolsPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SchoolsApiV1AnalyticsSchoolsPostError = SchoolsApiV1AnalyticsSchoolsPostErrors[keyof SchoolsApiV1AnalyticsSchoolsPostErrors];

export type SchoolsApiV1AnalyticsSchoolsPostResponses = {
    /**
     * Successful Response
     */
    200: SchoolsAnalytics;
};

export type SchoolsApiV1AnalyticsSchoolsPostResponse = SchoolsApiV1AnalyticsSchoolsPostResponses[keyof SchoolsApiV1AnalyticsSchoolsPostResponses];

export type CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostData = {
    body: AwaitingSchoolResponseRequest;
    path?: never;
    query?: never;
    url: '/api/v1/analytics/schools/awaiting-response';
};

export type CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostError = CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostErrors[keyof CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostErrors];

export type CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponses = {
    /**
     * Successful Response
     */
    200: AwaitingSchoolResponseResult;
};

export type CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponse = CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponses[keyof CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponses];

export type GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostData = {
    body: CandidateRecommendationInput;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/recommendation/candidate/generate';
};

export type GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostError = GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostErrors[keyof GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostErrors];

export type GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponses = {
    /**
     * Response Generate Recommendations For Candidate Api User Auth V1 Recommendation Candidate Generate Post
     *
     * Successful Response
     */
    200: Array<SchoolRecommendation>;
};

export type GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponse = GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponses[keyof GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponses];

export type GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostData = {
    body?: OptimizationSettings;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/recommendation/candidate/preference-weights';
};

export type GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostError = GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostErrors[keyof GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostErrors];

export type GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponses = {
    /**
     * Successful Response
     */
    200: CandidatePreferenceWeightsOutput;
};

export type GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponse = GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponses[keyof GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponses];

export type GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/recommendation/candidate';
};

export type GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetError = GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetErrors[keyof GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetErrors];

export type GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponses = {
    /**
     * Response Get Candidate Recommendations Endpoint Api User Auth V1 Recommendation Candidate Get
     *
     * Successful Response
     */
    200: Array<CandidateRecommendationItem>;
};

export type GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponse = GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponses[keyof GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponses];

export type GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/recommendation/candidate/counts';
};

export type GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetError = GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetErrors[keyof GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetErrors];

export type GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponses = {
    /**
     * Successful Response
     */
    200: CandidateCountsResponse;
};

export type GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponse = GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponses[keyof GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponses];

export type CreateActionApiUserAuthV1ActionPostData = {
    body: GatewayActionRequest;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/action/';
};

export type CreateActionApiUserAuthV1ActionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateActionApiUserAuthV1ActionPostError = CreateActionApiUserAuthV1ActionPostErrors[keyof CreateActionApiUserAuthV1ActionPostErrors];

export type CreateActionApiUserAuthV1ActionPostResponses = {
    /**
     * Successful Response
     */
    200: ActionResponse;
};

export type CreateActionApiUserAuthV1ActionPostResponse = CreateActionApiUserAuthV1ActionPostResponses[keyof CreateActionApiUserAuthV1ActionPostResponses];

export type GetCandidateInvitationsApiUserAuthV1InvitationsGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/invitations/';
};

export type GetCandidateInvitationsApiUserAuthV1InvitationsGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCandidateInvitationsApiUserAuthV1InvitationsGetError = GetCandidateInvitationsApiUserAuthV1InvitationsGetErrors[keyof GetCandidateInvitationsApiUserAuthV1InvitationsGetErrors];

export type GetCandidateInvitationsApiUserAuthV1InvitationsGetResponses = {
    /**
     * Successful Response
     */
    200: InvitationsResponse;
};

export type GetCandidateInvitationsApiUserAuthV1InvitationsGetResponse = GetCandidateInvitationsApiUserAuthV1InvitationsGetResponses[keyof GetCandidateInvitationsApiUserAuthV1InvitationsGetResponses];

export type GetInvitationsCountApiUserAuthV1InvitationsCountGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/invitations/count';
};

export type GetInvitationsCountApiUserAuthV1InvitationsCountGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetInvitationsCountApiUserAuthV1InvitationsCountGetError = GetInvitationsCountApiUserAuthV1InvitationsCountGetErrors[keyof GetInvitationsCountApiUserAuthV1InvitationsCountGetErrors];

export type GetInvitationsCountApiUserAuthV1InvitationsCountGetResponses = {
    /**
     * Successful Response
     */
    200: InvitationsCountResponse;
};

export type GetInvitationsCountApiUserAuthV1InvitationsCountGetResponse = GetInvitationsCountApiUserAuthV1InvitationsCountGetResponses[keyof GetInvitationsCountApiUserAuthV1InvitationsCountGetResponses];

export type GetConnectionsCountApiUserAuthV1ConnectionsCountGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/connections/count';
};

export type GetConnectionsCountApiUserAuthV1ConnectionsCountGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetConnectionsCountApiUserAuthV1ConnectionsCountGetError = GetConnectionsCountApiUserAuthV1ConnectionsCountGetErrors[keyof GetConnectionsCountApiUserAuthV1ConnectionsCountGetErrors];

export type GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponses = {
    /**
     * Successful Response
     */
    200: ConnectionsCountResponse;
};

export type GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponse = GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponses[keyof GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponses];

export type GetConnectionsApiUserAuthV1ConnectionsCandidateGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/connections/candidate';
};

export type GetConnectionsApiUserAuthV1ConnectionsCandidateGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetConnectionsApiUserAuthV1ConnectionsCandidateGetError = GetConnectionsApiUserAuthV1ConnectionsCandidateGetErrors[keyof GetConnectionsApiUserAuthV1ConnectionsCandidateGetErrors];

export type GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponses = {
    /**
     * Successful Response
     */
    200: ConnectionsResponse;
};

export type GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponse = GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponses[keyof GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponses];

export type GetQuizStatusApiUserAuthV1QuizStatusGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/quiz/status';
};

export type GetQuizStatusApiUserAuthV1QuizStatusGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetQuizStatusApiUserAuthV1QuizStatusGetError = GetQuizStatusApiUserAuthV1QuizStatusGetErrors[keyof GetQuizStatusApiUserAuthV1QuizStatusGetErrors];

export type GetQuizStatusApiUserAuthV1QuizStatusGetResponses = {
    /**
     * Successful Response
     */
    200: QuizStatusResponse;
};

export type GetQuizStatusApiUserAuthV1QuizStatusGetResponse = GetQuizStatusApiUserAuthV1QuizStatusGetResponses[keyof GetQuizStatusApiUserAuthV1QuizStatusGetResponses];

export type GetQuizQuestionsApiUserAuthV1QuizQuestionsGetData = {
    body?: never;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/quiz/questions';
};

export type GetQuizQuestionsApiUserAuthV1QuizQuestionsGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetQuizQuestionsApiUserAuthV1QuizQuestionsGetError = GetQuizQuestionsApiUserAuthV1QuizQuestionsGetErrors[keyof GetQuizQuestionsApiUserAuthV1QuizQuestionsGetErrors];

export type GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponses = {
    /**
     * Successful Response
     */
    200: QuizQuestionsResponse;
};

export type GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponse = GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponses[keyof GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponses];

export type SaveResponseApiUserAuthV1QuizResponsesPostData = {
    body: CandidateResponsePayload;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/quiz/responses';
};

export type SaveResponseApiUserAuthV1QuizResponsesPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SaveResponseApiUserAuthV1QuizResponsesPostError = SaveResponseApiUserAuthV1QuizResponsesPostErrors[keyof SaveResponseApiUserAuthV1QuizResponsesPostErrors];

export type SaveResponseApiUserAuthV1QuizResponsesPostResponses = {
    /**
     * Successful Response
     */
    200: SaveResponseResult;
};

export type SaveResponseApiUserAuthV1QuizResponsesPostResponse = SaveResponseApiUserAuthV1QuizResponsesPostResponses[keyof SaveResponseApiUserAuthV1QuizResponsesPostResponses];

export type GetMatchStatusApiUserAuthV1MatchesStatusPostData = {
    body: MatchStatusRequest;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/matches/status';
};

export type GetMatchStatusApiUserAuthV1MatchesStatusPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetMatchStatusApiUserAuthV1MatchesStatusPostError = GetMatchStatusApiUserAuthV1MatchesStatusPostErrors[keyof GetMatchStatusApiUserAuthV1MatchesStatusPostErrors];

export type GetMatchStatusApiUserAuthV1MatchesStatusPostResponses = {
    /**
     * Response Get Match Status Api User Auth V1 Matches Status Post
     *
     * Successful Response
     */
    200: Array<ConnectionInitiatedItem>;
};

export type GetMatchStatusApiUserAuthV1MatchesStatusPostResponse = GetMatchStatusApiUserAuthV1MatchesStatusPostResponses[keyof GetMatchStatusApiUserAuthV1MatchesStatusPostResponses];

export type ExpressInterestApiUserAuthV1MatchesExpressInterestPostData = {
    body: ExpressInterestRequest;
    headers: {
        /**
         * X-User-Id
         */
        'x-user-id': string;
    };
    path?: never;
    query?: never;
    url: '/api/user-auth/v1/matches/express_interest';
};

export type ExpressInterestApiUserAuthV1MatchesExpressInterestPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExpressInterestApiUserAuthV1MatchesExpressInterestPostError = ExpressInterestApiUserAuthV1MatchesExpressInterestPostErrors[keyof ExpressInterestApiUserAuthV1MatchesExpressInterestPostErrors];

export type ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponses = {
    /**
     * Successful Response
     */
    200: ExpressInterestResponse;
};

export type ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponse = ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponses[keyof ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponses];

export type GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostData = {
    body: CandidateActivityRequest;
    path?: never;
    query?: never;
    url: '/api/service-auth/v1/recommendation/candidates/activity';
};

export type GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostError = GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostErrors[keyof GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostErrors];

export type GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponses = {
    /**
     * Response Get Candidates Activity Api Service Auth V1 Recommendation Candidates Activity Post
     *
     * Successful Response
     */
    200: Array<CandidateActivityItem>;
};

export type GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponse = GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponses[keyof GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponses];
